import { useState } from "react";
import { Button, Segment, Icon, Input } from "semantic-ui-react";

import RuvixxForm from "components/RuvixxForm";

import styles from "./FollowupOptionsForm.module.scss";

const FollowupOptionsForm = ({ question, onSuccess, updateQuestion }) => {
  // The modal unmounts this form while closed, so each open starts from the
  // question's current options.
  const [options, setOptions] = useState(question?.options || []);

  const handleAdd = () => {
    const emptyOption = {
      label: "",
      value: "",
    };
    const newOptions = [...options, emptyOption];
    setOptions(newOptions);
  };

  const handleRemove = index => {
    updateOptionAtIndex(index);
  };

  const updateOptionAtIndex = (index, option = null) => {
    let newOptions;
    if (option) {
      newOptions = [
        ...options.slice(0, index),
        option,
        ...options.slice(index + 1),
      ];
    } else {
      newOptions = [...options.slice(0, index), ...options.slice(index + 1)];
    }
    setOptions(newOptions);
  };

  const handleChange = (data, index) => {
    const { value } = data;
    const option = {
      label: value,
      value,
    };
    updateOptionAtIndex(index, option);
  };

  const handleSubmit = () => {
    const newQuestion = {
      ...question,
      options,
    };
    updateQuestion(newQuestion);
  };

  const renderOption = (option, index) => {
    const { label } = option;
    return (
      <Segment className="option" key={index}>
        <div className="left">
          <Input
            value={label}
            placeholder={`Option ${index + 1}`}
            onChange={(_, data) => handleChange(data, index)}
            autoFocus={label === ""}
          />
        </div>
        <div className="right">
          <Icon name="close" link onClick={() => handleRemove(index)} />
        </div>
      </Segment>
    );
  };

  return (
    <RuvixxForm
      ready
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
      submitButtonText="Save"
      className={styles["options-form"]}
    >
      <Button
        basic
        size="tiny"
        icon="plus"
        content="Add Option"
        onClick={handleAdd}
      />
      {options.length > 0 && (
        <Segment.Group>{options.map(renderOption)}</Segment.Group>
      )}
    </RuvixxForm>
  );
};

export default FollowupOptionsForm;
